import { gql, useMutation } from "@apollo/client";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { AiFillApi, AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import HeadtlerLogo from "../../../Assets/Logo/HeadtlerLogo.png";
import HeadlerLogo from "../../../Assets/icons/ERP_Logo.png";
import Button from "../../Components/Button/Button";
import Errormessage from "../../Components/Errormessage/Errormessage";
import Image from "../../Components/Image/Image";
import Input from "../../Components/Input/Input";
import Spinner from "../../Components/Spinner/Spinner";
import { ErrorToast, SuccessToast, WarningToast } from "../../Components/ToastComponent/RectHotToast";
import OtpInput from "./OtpInput";
import "./login.scss";

const LOGIN_AND_SEND_OTP_MUTATION = gql`
  mutation LoginAndSendOtp($loginInput: OTPloginInput!) {
    loginAndSendOtp(loginInput: $loginInput) {
      message
    }
  }
`;

const CHECK_OTP_MUTATION = gql`
  mutation LoginAndCheckOtp($loginInput: OTPcheck!) {
    loginAndCheckOtp(loginInput: $loginInput) {
      token
      LicenseeCode
      userDetails {
        _id
        Account_ID
        User_ID
        Default_Company {
          _id
          Unique_Id
          Name
          Search_Value
          Address
          State
          City
          Pincode
          Status
          Company_Code
          Email
          GST_Number
          createdAt
          updatedAt
        }
        Default_Branch {
          _id
          Unique_Id
          Name
          Branch_Code
          Company_ID
          Search_Value
          Address
          State
          City
          Pincode
          Email
          Mobile_Number
          GST_Number
          createdAt
          updatedAt
        }
        Department
        Mobile
        Email
        Full_Name
        UserName
        Password
        Role {
          _id
          Unique_Id
          Role
          RoleType
          Copy_Role_From
          Back_Year_View_Rights
          Module_Rights
          createdAt
          updatedAt
        }
        Is_Active
        View_Only_Self_Entry
        View_Only_Current_Year
        Super_Access_User
        Allow_Audit
        Merge_Balance
        createdAt
        updatedAt
      }
      message
      BookMarks {
        Page_Rights {
          _id
          Unique_Id
          Page_Name
          Page_Access
          Role_Id
          Route
          Module_Right_Id
          Page_Id
          Is_Add
          Is_View
          Is_Edit
          Is_Delete
          Is_Merge
          Export
          Is_Lock
          Is_Unlock
          Audit
          UnAudit
          Serial_No
          createdAt
          updatedAt
        }
      }
      CompanyAccess {
        _id
        Unique_Id
        Company_ID {
          _id
          Unique_Id
          Name
          Search_Value
          Address
          State
          City
          Pincode
          Status
          Company_Code
          Email
          GST_Number
          createdAt
          updatedAt
        }
        BranchAccess_Code {
          _id
          Unique_Id
          Name
          Branch_Code
          Company_ID
          Search_Value
          Address
          State
          City
          Pincode
          Email
          Mobile_Number
          GST_Number
          createdAt
          updatedAt
        }
        User_ID
        createdAt
        updatedAt
      }
      PageRightsAccess {
        _id
        Unique_Id
        Menu_Name
        createdAt
        updatedAt
        Modules {
          _id
          Unique_Id
          Module_Access
          Module_Id
          Menu_Id
          Module_Name
          Serial_No
          createdAt
          updatedAt
          Page {
            _id
            Unique_Id
            Page_Name
            Page_Access
            Role_Id
            Serial_No
            Route
            Module_Right_Id
            Page_Id
            Is_Add
            Is_View
            Is_Edit
            Is_Delete
            Is_Lock
            Is_Unlock
            Export
            Audit
            UnAudit
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;

const Login = () => {
  const signInButtonRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [otpSend, setOtpSend] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(30);
  const [timeExpired, setTimeExpired] = useState(false);
  const [sendOtpMutation, { loading: sendingOtp }] = useMutation(LOGIN_AND_SEND_OTP_MUTATION);
  const [checkOtpMutation, { loading: checkingOtp }] = useMutation(CHECK_OTP_MUTATION);

  useEffect(() => {
    const countdown = setInterval(() => {
      if (minutes === 0 && seconds === 0) {
        clearInterval(countdown);
        setTimeExpired(true);
      } else {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => clearInterval(countdown);
  }, [minutes, seconds]);

  useEffect(() => {
    if (otp.length === 4 && signInButtonRef.current) {
      signInButtonRef.current.focus();
    }
  }, [otp]);
  useEffect(() => {
    console.log(otp, timeExpired);
    if (otp.length === 4 && !timeExpired) {
      checkOtpRequest({
        User_Name: formik.values.User_Name,
        Password: formik.values.Password,
        Licensee_Code: formik.values.Licensee_Code,
        OTP: otp.join(""),
      });
    } else if (timeExpired && otp.length === 4) {
      WarningToast("OTP is Expired or Invalid ");
    }
  }, [otp]);

  const sendOtpRequest = async ({ User_Name, Password, Licensee_Code }) => {
    try {
      await sendOtpMutation({
        variables: {
          loginInput: {
            UserName: User_Name,
            Password,
            LicenseeCode: Licensee_Code,
          },
        },
      }).then((res) => {
        if (res.errors) {
          throw new Error(res?.errors[0]?.message);
        }
        setMinutes(0);
        setSeconds(30);
        console.log(res, "resresresresresres");
        SuccessToast(res.data.loginAndSendOtp.message);

        setOtpSend(true);
      });
    } catch (err) {
      ErrorToast(err.message);
    }
  };

  const checkOtpRequest = async ({ User_Name, Password, Licensee_Code, OTP }) => {
    try {
      await checkOtpMutation({
        variables: {
          loginInput: {
            UserName: User_Name,
            Password,
            LicenseeCode: Licensee_Code,
            otp: parseInt(OTP),
          },
        },
      }).then((res) => {
        sessionStorage.setItem("LicenseeCode", res.data.loginAndCheckOtp.LicenseeCode);
        sessionStorage.setItem("userData", JSON.stringify(res.data.loginAndCheckOtp));
        sessionStorage.setItem("tokenf", res.data.loginAndCheckOtp.token);
        sessionStorage.setItem("userRights", JSON.stringify(res.data.loginAndCheckOtp.PageRightsAccess));
        SuccessToast(res.data.loginAndCheckOtp.message);
        let compObj = {
          Name: res.data.loginAndCheckOtp.userDetails[0]?.Default_Company?.Name,
          id: res?.data?.loginAndCheckOtp?.userDetails[0]?.Default_Company?._id,
          CompanyCode: res?.data?.loginAndCheckOtp?.userDetails[0]?.Default_Company?.Unique_Id,
          CompanyCodeName: res?.data?.loginAndCheckOtp?.userDetails[0]?.Default_Company?.Company_Code,
          GST_Number: res?.data?.loginAndCheckOtp?.userDetails[0]?.Default_Company?.GST_Number,
          Pincode: res?.data?.loginAndCheckOtp?.userDetails[0]?.Default_Company?.Pincode,
          State: res?.data?.loginAndCheckOtp?.userDetails[0]?.Default_Company?.State,
        };
        let branchObj = {
          Name: res?.data?.loginAndCheckOtp?.userDetails[0]?.Default_Branch?.Name,
          id: res?.data?.loginAndCheckOtp?.userDetails[0]?.Default_Branch?._id,
          BranchCode: res?.data?.loginAndCheckOtp?.userDetails[0]?.Default_Branch?.Unique_Id,
          GST_Number: res?.data?.loginAndCheckOtp?.userDetails[0]?.Default_Branch?.GST_Number,
          Search_Value: res?.data?.loginAndCheckOtp?.userDetails[0]?.Default_Branch?.Search_Value,
        };
        sessionStorage.setItem("CompanyCode", JSON.stringify(compObj));
        sessionStorage.setItem("BranchCode", JSON.stringify(branchObj));
        console.log(compObj, branchObj, "branchObjbranchObj");
        dispatch({
          type: "ChangeCompanyAndBranch",
          payload: { ...compObj, ...branchObj },
        });

        dispatch({ type: "Login", payload: res.data });
        navigate("/", { replace: true }); // This replaces the login page in the history stack
      });
    } catch (err) {
      console.log(err.message);
      ErrorToast(err.message);
      setOtp([]);
      const firstInput = document.getElementsByClassName("otp-input");
      if (firstInput.length > 0) {
        firstInput[0].focus();
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      Licensee_Code: "",
      User_Name: "",
      Password: "",
    },
    onSubmit: (values) => {
      // console.log(values, timeExpired, "timeExpiredtimeExpiredtimeExpiredtimeExpired");
      if (!otpSend) {
        sendOtpRequest(values);
        setTimeExpired(false);
      } else {
        checkOtpRequest({
          ...values,
          OTP: otp.join(""),
        });
      }
    },
    validate: (values) => {},
  });

  const handleResend = (values) => {
    console.log(values, "valuesvaluesvaluesvaluesvalues");
    setOtp([]);
    sendOtpRequest(values);
    setTimeExpired(false);
  };

  return (
    <div className="LoginContainer">
      <div className="logo-container">
        <img width={"600px"} height={"600px"} src={HeadlerLogo} alt="logo"></img>
      </div>
      <div>
        <div className="loginpage">
          <div className="loginbox">
            <div className="boxcenter">
              <Image img={HeadtlerLogo} height={"100px"} width={"100px"} />
            </div>
            <div className="boxcenter">
              <form onSubmit={formik.handleSubmit} autoComplete="off">
                {!otpSend && (
                  <>
                    <div className="Icon-inside">
                      <Input
                        EMTQuery=""
                        checked={""}
                        InputConfig={{ AllCaps: true, autoFocus: true }}
                        type={"text"}
                        name={"Licensee_Code"}
                        value={formik.values.Licensee_Code}
                        handleInputChange={formik.handleChange}
                        handleBlur={formik.handleBlur}
                        disabled={otpSend ? true : false}
                      />
                      <i aria-hidden="true">
                        <AiFillApi color="#cac5c5" size={"24px"} />
                      </i>
                    </div>

                    {formik.errors.Licensee_Code ? <Errormessage text={formik.errors.Licensee_Code} /> : null}

                    <div className="Icon-inside">
                      <Input
                        EMTQuery=""
                        checked={""}
                        InputConfig=""
                        type={"text"}
                        name={"User_Name"}
                        value={formik.values.User_Name}
                        handleInputChange={formik.handleChange}
                        handleBlur={formik.handleBlur}
                        disabled={otpSend ? true : false}
                      />
                      <i aria-hidden="true">
                        <AiFillApi color="#cac5c5" size={"24px"} />
                      </i>
                    </div>

                    {formik.errors.User_Name ? <Errormessage text={formik.errors.User_Name} /> : null}

                    <div className="Icon-inside">
                      <Input
                        EMTQuery=""
                        checked={""}
                        InputConfig=""
                        type={showPassword ? "text" : "password"}
                        name={"Password"}
                        value={formik.values.Password}
                        handleInputChange={formik.handleChange}
                        handleBlur={formik.handleBlur}
                        disabled={otpSend ? true : false}
                      />
                      <i aria-hidden="true">
                        <AiFillApi color="#cac5c5" size={"24px"} />
                      </i>
                      <div className="password-icon" onClick={() => setShowPassword((prev) => !prev)}>
                        {showPassword ? (
                          <AiOutlineEye color="#333" size={20} />
                        ) : (
                          <AiOutlineEyeInvisible color="#333" size={20} />
                        )}
                      </div>
                    </div>

                    {formik.errors.Password ? <Errormessage text={formik.errors.Password} /> : null}
                  </>
                )}

                {otpSend && (
                  <div>
                    <OtpInput
                      otpValue={otp}
                      onOtpChange={(newOtp) => setOtp(newOtp.split(""))}
                      onComplete={() => signInButtonRef.current?.focus()}
                    />
                    {timeExpired ? (
                      <></>
                    ) : (
                      <>
                        <h5 className="Otp-timer">
                          OTP Resend In : {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                        </h5>
                      </>
                    )}
                  </div>
                )}
                {formik.errors.OTP ? <Errormessage text={formik.errors.OTP} /> : null}
                <div style={{ marginTop: "20px" }}>
                  <Button
                    text={!otpSend ? "Send OTP" : <>{sendingOtp || checkingOtp ? <Spinner /> : "Sign In"}</>}
                    name="signin"
                    type={"submit"}
                    ref={otpSend ? signInButtonRef : null}
                    loadingState={!otpSend ? sendingOtp : checkingOtp}
                  />

                  {timeExpired && otpSend && (
                    <Button
                      text={"Resend OTP"}
                      name="resend"
                      action={() => {
                        handleResend(formik.values);
                      }}
                    />
                  )}
                  {otpSend && (
                    <Button
                      text="Back"
                      name="back"
                      action={() => {
                        navigate(-1);
                      }}
                    />
                  )}
                  <Button text="Support" name="support" disabled={true} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
